// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"385":"9a30f8af","442":"c42971f6","461":"eaed8451","518":"7d2425ec","520":"5c435346"}[chunkId] + ".css";
};